/* Royal · +2 matching pillowcases add-on (see snippets/royal-pc-addon.liquid). Loaded with defer, so the Add to cart
   button below the add-on already exists when this runs. */
(function () {
  document.querySelectorAll('[data-rpa]').forEach(function (root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  var sid = root.dataset.sid, pcId = parseInt(root.dataset.pcId, 10), pcNow = parseInt(root.dataset.pcNow, 10);
  var base = parseInt(root.dataset.base, 10) || 0, fmt = root.dataset.fmt || '';
  var check = root.querySelector('[data-rpa-check]'), box = root.querySelector('.rpa-box');
  var btn = document.getElementById('ProductSubmitButton-' + sid);
  if (!btn) return;
  var pf = btn.closest('product-form'), form = btn.form || (pf && pf.querySelector('form'));
  if (!pf || !form) return;

  function money(c) {
    var s = (c / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return fmt && /amount/.test(fmt) ? fmt.replace(/\{\{\s*amount[^}]*\}\}/, s) : s + ' EGP';
  }
  function on() { return check.checked && !btn.disabled; }
  function qty() { var q = form.querySelector('[name="quantity"]'); return (q && parseInt(q.value, 10)) || 1; }
  /* the total sits in its own span after the button label, so the theme's own label changes are untouched */
  function sum() {
    var s = btn.querySelector('.rpa-sum');
    if (!s) { s = document.createElement('span'); s.className = 'rpa-sum'; var l = btn.querySelector('span'); if (l) l.after(s); else btn.prepend(s); }
    s.textContent = on() ? ' · ' + money(base * qty() + pcNow) : '';
    box.classList.toggle('is-on', check.checked);
    root.hidden = btn.disabled;
    /* phone sticky bar (snippets/royal-pdp-sticky): its button carries the same total while the box is ticked
       (2026-10-21, option 3B of artifact M7ayLShSPFnmNVzPQNTZHP); the price beside it stays the set's own price */
    var sb = document.querySelector('[data-rpk-btn]');
    if (sb) {
      if (!sb.dataset.label) sb.dataset.label = sb.textContent.trim();
      var short = document.documentElement.lang === 'ar' ? 'أضف' : 'Add';
      sb.textContent = on() ? short + ' · ' + money(base * qty() + pcNow) : sb.dataset.label;
    }
  }
  check.addEventListener('change', sum);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var v = e && e.data && e.data.variant;
      if (v && typeof v.price === 'number') base = v.price;
      setTimeout(sum, 80);
    });
  }
  sum();

  function busy(b) {
    btn.classList.toggle('loading', b);
    var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.toggle('hidden', !b);
    if (b) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
  }
  function setOnly() { check.checked = false; sum(); form.requestSubmit ? form.requestSubmit() : btn.click(); }

  /* Add to cart: set + pillowcases in one request, then the drawer opens as usual. If the pillowcases can't be added
     (e.g. just sold out), the box unticks and the set is added on its own through the theme's normal path. */
  pf.addEventListener('submit', function (e) {
    if (!on()) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var setId = parseInt(new FormData(form).get('id'), 10);
    if (!setId) return;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: setId, quantity: qty() }, { id: pcId, quantity: 1 }] };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    busy(true);
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        busy(false);
        if (res.status) { setOnly(); return; }
        if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
        if (res.items && res.items[0]) { res.id = res.items[0].id; res.key = res.items[0].key; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: setId, cartData: res });
        cart.renderContents(res);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function () { busy(false); setOnly(); });
  }, true);

  /* Buy it now: straight to checkout with exactly the set and the pillowcases, like the normal Buy it now. */
  pf.addEventListener('click', function (e) {
    if (!on()) return;
    var path = e.composedPath ? e.composedPath() : [e.target];
    var hit = path.some(function (n) { return n && n.classList && (n.classList.contains('shopify-payment-button__button') || n.classList.contains('shopify-payment-button')); });
    if (!hit) return;
    var setId = parseInt(new FormData(form).get('id'), 10);
    if (!setId) return;
    e.preventDefault(); e.stopPropagation();
    window.location.href = '/cart/' + setId + ':' + qty() + ',' + pcId + ':1';
  }, true);
  });
})();
